export const AdminPath = process.env.REACT_APP_ADMIN_PATH;
